export default "__VITE_ASSET__8322eed2__"